import { t } from "i18next";
import * as Yup from 'yup';

export function getHostingSiteValidationScheme() {
    return Yup.object().shape({
        name: Yup.string().required(t("Required")),
        address: Yup.string().required(t("Required"))
    })
}